import React, { useCallback, useState } from 'react';
import AddGif from '@wix/da-ds/pkg/Icons/24x24/AddGif';
import GiphyPopup from '../../lego/GiphyPopup';
import { isExtensionInstalled } from '../../utils/tiptap';
import { useTranslation } from 'react-i18next';
import EditorIconButton from '../_partials/EditorIconButton';
const Gif = ({ editor, hideWhenNotEnabled = true })=>{
    const { t } = useTranslation('editor');
    const [showGiphyPopup, setShowGiphyPopup] = useState(false);
    const hideGiphyPopup = useCallback(()=>{
        setShowGiphyPopup(false);
    }, [
        setShowGiphyPopup
    ]);
    const onSelect = useCallback((gif)=>{
        editor.chain().focus().daGifAddGif({
            width: gif.width,
            height: gif.height,
            url: gif.originalMp4
        }).run();
    }, [
        editor
    ]);
    if (!editor.isEditable || hideWhenNotEnabled && !isExtensionInstalled(editor, 'gif')) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(EditorIconButton, {
        featureId: "node:gif",
        tooltipText: t('button.gif.tooltip'),
        "aria-label": t('button.gif.tooltip'),
        icon: AddGif,
        onClick: ()=>setShowGiphyPopup(true)
    }), showGiphyPopup && /*#__PURE__*/ React.createElement(GiphyPopup, {
        onClose: hideGiphyPopup,
        onSelect: onSelect
    }));
};
Gif.displayName = 'Gif';
export default Gif;

//# sourceMappingURL=Gif.js.map